var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayVideo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#060606"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3953 14.4619L13.5875 15.5145L11.7798 16.567C9.44955 17.9182 7.54297 16.8088 7.54297 14.1064V12.0013V9.89626C7.54297 7.17961 9.44955 6.08441 11.7798 7.43563L13.5875 8.48815L15.3953 9.54068C17.7255 10.8919 17.7255 13.1107 15.3953 14.4619Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayVideo);
export default __webpack_public_path__ + "static/media/play-video.d1a5dd82d6eca9bdb223ca8ee92b78e5.svg";
export { ForwardRef as ReactComponent };